import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "downloadModal", "downloadText" ]

    connect() {
      this.relocateCardModals()
      this.modalObserver = new MutationObserver(() => this.relocateCardModals())
      this.modalObserver.observe(this.element, { childList: true, subtree: true })
    }

    disconnect() {
      if (this.modalObserver) this.modalObserver.disconnect()
    }

    relocateCardModals() {
      const modalHost = this.element.querySelector(".portal-providers-body")
      if (!modalHost) return

      this.element.querySelectorAll(".portal-provider-card .modal").forEach((modal) => {
        modalHost.appendChild(modal)
      })
    }

    list(event) {
      const letter = event.currentTarget.dataset.letter || event.currentTarget.innerText.trim()
      const params = new URLSearchParams(window.location.search)

      params.set("letter", letter)
      params.delete("search_query")
      params.delete("counter")

      window.location.assign(`/portal?${params.toString()}`)
    }

    filterLocation(event) {
      const params = new URLSearchParams(window.location.search)
      const location = event.currentTarget.value

      params.delete("counter")

      if (location) {
        params.set("provider_location", location)
      } else {
        params.delete("provider_location")
      }

      window.location.assign(`/portal?${params.toString()}`)
    }

    download(event) {
      event.preventDefault()

      const link = event.currentTarget
      const format = link.dataset.exportFormat || "file"

      this.showDownloadModal(`${format.toUpperCase()} provider list is being created. This may take a moment.`)

      fetch(link.href, { credentials: "same-origin" })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Download failed")
          }

          return response.blob().then((blob) => {
            this.triggerDownload(blob, this.filenameFromResponse(response, link.href))
          })
        })
        .then(() => {
          this.showDownloadModal("Download ready.")
          window.setTimeout(() => this.hideDownloadModal(), 900)
        })
        .catch(() => {
          this.showDownloadModal("Something went wrong while creating the download. Please try again.")
          window.setTimeout(() => this.hideDownloadModal(), 3000)
        })
    }

    showDownloadModal(message) {
      if (this.hasDownloadTextTarget) {
        this.downloadTextTarget.innerText = message
      }

      if (this.hasDownloadModalTarget) {
        this.downloadModalTarget.classList.remove("d-none")
        this.downloadModalTarget.setAttribute("aria-hidden", "false")
      }
    }

    hideDownloadModal() {
      if (this.hasDownloadModalTarget) {
        this.downloadModalTarget.classList.add("d-none")
        this.downloadModalTarget.setAttribute("aria-hidden", "true")
      }
    }

    triggerDownload(blob, filename) {
      const url = window.URL.createObjectURL(blob)
      const anchor = document.createElement("a")

      anchor.href = url
      anchor.download = filename
      document.body.appendChild(anchor)
      anchor.click()
      anchor.remove()
      window.URL.revokeObjectURL(url)
    }

    filenameFromResponse(response, fallbackUrl) {
      const disposition = response.headers.get("Content-Disposition")
      const filenameMatch = disposition && disposition.match(/filename="?([^"]+)"?/)

      if (filenameMatch && filenameMatch[1]) {
        return filenameMatch[1]
      }

      return fallbackUrl.includes(".pdf") ? "providers.pdf" : "providers.xlsx"
    }
}
